<p-card>
  @if (showHeader()) {
    <div class="flex items-center justify-between mb-2">
      <div class="flex items-center gap-2">
        <i class="pi pi-folder text-gray-600"></i>
        <h3 class="text-lg font-semibold text-gray-900">Documents</h3>
      </div>
      <p-button
        label="+ Upload"
        styleClass="bg-blue-600 hover:bg-blue-700 text-white border-0"
        size="small"
        (onClick)="uploadDocument()"
      ></p-button>
    </div>
  }

  <div class="w-full hidden" [formGroup]="formGroup()">
    <app-one-to-many
      title="Upload Document"
      [service]="fileUploadService"
      [defaultSort]="defaultSort()"
      [cols]="cols()"
      [componentType]="fileUploadComponentType"
      width="min(36rem, 92vw)"
      height="auto"
      [fields]="fields()"
      id="documentID-hidden"
      [hasFile]="true"
      (onDataChange)="onDataDocument($event)"
      [parentIdKey]="parentIdKey()"
      [foreingKeyName]="foreignKeyName()"
      [isViewOnly]="true"
      [isLimitedPagination]="true"
      [limitedCount]="5"
      [showNewBtn]="false"
      [editWithoutFetchId]="true"
      editTitle="Edit document"
    ></app-one-to-many>
  </div>

  @if (paginatedDocuments().length > 0) {
    <div class="w-full" [formGroup]="formGroup()">
      <div class="hidden">
        <app-one-to-many
          title="Upload Document"
          [service]="fileUploadService"
          [defaultSort]="defaultSort()"
          [cols]="cols()"
          [componentType]="fileUploadComponentType"
          width="min(36rem, 92vw)"
          height="auto"
          [fields]="fields()"
          id="documentID"
          [hasFile]="true"
          (onDataChange)="onDataDocument($event)"
          [parentIdKey]="parentIdKey()"
          [foreingKeyName]="foreignKeyName()"
          [isViewOnly]="true"
          [isLimitedPagination]="true"
          [limitedCount]="5"
          [showNewBtn]="false"
        ></app-one-to-many>
      </div>

      <div class="documents-cards-container mt-2">
        @for (doc of paginatedDocuments(); track doc.documentID) {
          <div
            class="document-card"
            [class.pointer-events-none]="deletingDocumentId()"
            [class.opacity-60]="deletingDocumentId()"
            (click)="onDocumentCardClick(doc)"
            title="Click to edit"
          >
            <div class="document-card-header">
              <div class="document-top-row">
                <h4 class="document-card-type">{{ doc.typeDescription || doc.type || 'Unknown Type' }}</h4>
                <div class="document-header-right flex items-center gap-2 shrink-0">
                  @if (doc.createdOn) {
                    <button
                      type="button"
                      class="date-toggle-button"
                      (click)="toggleDocumentDateDisplay(doc, $event)"
                    >
                      @if (isOfficialDocumentDate(doc)) {
                        {{ doc.createdOn | utcToLocal | date: 'MMM d, yyyy h:mm a' }}
                      } @else {
                        {{ doc.createdOn | utcToLocal | relativeDateLabel }}
                      }
                    </button>
                  }
                  @if (canDeleteDocument()) {
                    <div class="document-card-actions" (click)="$event.stopPropagation()">
                      <button
                        type="button"
                        class="document-card-remove-button document-action-icon"
                        [class.opacity-40]="isDeletingDocument(doc)"
                        [class.pointer-events-none]="deletingDocumentId()"
                        (click)="confirmDeleteDocument($event, doc)"
                        [pTooltip]="'Delete'"
                        tooltipPosition="top"
                        [attr.aria-label]="'Delete document'"
                      >
                        <i class="pi pi-times" aria-hidden="true"></i>
                      </button>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="document-card-body">
              <div class="document-card-body-row">
                <p class="document-card-name">{{ doc.documentName || '--' }}</p>
                <i
                  class="pi pi-download document-action-icon document-card-download text-blue-600 hover:text-blue-800 cursor-pointer text-lg shrink-0"
                  [class.pointer-events-none]="deletingDocumentId()"
                  (click)="downloadDocument(doc); $event.stopPropagation()"
                  [pTooltip]="'Download'"
                  tooltipPosition="top"
                ></i>
              </div>
            </div>
          </div>
        }
      </div>

      @if (enablePagination() && documentsList().length > pageSize()) {
        <app-pagination-mobile-version
          [totalRecords]="documentsList().length"
          [skip]="documentsSkip()"
          [take]="documentsTake()"
          [rowsPerPageOptions]="rowsPerPageOptions()"
          (pageChange)="onDocumentsPageChange($event)"
        >
        </app-pagination-mobile-version>
      }
    </div>
  }

  @if (!showHeader()) {
    <button
      type="button"
      class="mt-3 inline-flex w-full cursor-pointer items-center justify-center gap-1.5 rounded-lg border border-dashed border-slate-300 bg-white px-3 py-2 text-sm font-medium text-blue-600 transition-colors hover:border-blue-300 hover:bg-blue-50"
      (click)="uploadDocument()"
    >
      <i class="pi pi-plus text-xs"></i>
      Upload document
    </button>
  }
</p-card>

<p-confirmDialog styleClass="quote-delete-confirm-dialog" />
